import type { MessageSchema } from './en'

const pt: MessageSchema = {
  common: {
    cancel: 'Cancelar',
    create: 'Criar',
    save: 'Salvar',
    saving: 'Salvando…',
    refresh: 'Atualizar',
    loading: 'Carregando…'
  },
  nav: {
    products: 'Produtos',
    upload: 'Carregar',
    adhoc: 'Ad hoc',
    reports: 'Relatórios',
    settings: 'Configurações'
  },
  sidebar: {
    expand: 'Expandir',
    collapse: 'Recolher',
    expandSidebar: 'Expandir a barra lateral',
    collapseSidebar: 'Recolher a barra lateral',
    logout: 'Sair'
  },
  topbar: {
    welcome: 'Bem-vindo, {name}',
    selectLanguage: 'Selecionar idioma'
  },
  footer: {
    copyright: 'Copyright © {year} Avalara Inc. Todos os direitos reservados.'
  },
  auth: {
    redirecting: 'Redirecionando para o início de sessão…',
    completing: 'Concluindo a autenticação…',
    noCode: 'Nenhum código de autorização recebido',
    failed: 'Falha na autenticação. Tente novamente.',
    tryAgain: 'Tentar novamente'
  },
  settings: {
    profiles: 'Perfis',
    users: 'Usuários'
  },
  reporting: {
    userTitle: 'Relatórios de usuário',
    userSubtitle: 'Visualize e baixe os relatórios relacionados à sua atividade',
    userEmpty: 'Não há relatórios disponíveis no momento.',
    profileTitle: 'Relatórios de perfil',
    profileSubtitle: 'Visualize e baixe os relatórios relacionados à atividade do seu perfil',
    profileEmpty: 'Não há relatórios de perfil disponíveis no momento.',
    loading: 'Carregando relatórios…',
    emptyTitle: 'Nenhum relatório disponível',
    download: 'Baixar',
    loadFailed: 'Falha ao carregar os relatórios'
  },
  eccn: {
    title: 'Classificação ECCN de autoatendimento',
    subtitle: 'Insira a descrição do seu produto para obter uma classificação ECCN automatizada',
    productLabel: 'Descrição do produto',
    productPlaceholder: 'Insira uma descrição detalhada do produto, especificações e uso pretendido…',
    descriptionRequired: 'Insira uma descrição do produto',
    clear: 'Limpar',
    classify: 'Classificar produto',
    classifying: 'Classificando…',
    resultTitle: 'Resultado da classificação',
    confidence: '{value}% de confiança',
    code: 'ECCN',
    description: 'Descrição',
    controlReason: 'Motivo do controle',
    exportRestrictions: 'Restrições de exportação',
    noRestrictions: 'Sem restrições específicas',
    downloadReport: 'Baixar relatório',
    saveClassification: 'Salvar classificação',
    readyTitle: 'Pronto para classificar',
    readyHint: 'Insira uma descrição do produto e clique em "{action}" para começar'
  },
  dashboard: {
    totalProducts: 'Total de produtos',
    totalProductsChange: '+12% em relação ao mês passado',
    classifications: 'Classificações',
    classificationsChange: 'Produtos verificados hoje',
    activeUsers: 'Usuários ativos',
    activeUsersChange: 'On-line no momento',
    complianceRate: 'Taxa de conformidade',
    complianceRateChange: '+2,1% de melhoria',
    quickUpload: 'Carregamento rápido',
    quickUploadHint: 'Carregue e classifique novos produtos rapidamente',
    dropFiles: 'Arraste e solte seus arquivos aqui',
    browseFiles: 'Procurar arquivos',
    recentActivity: 'Atividade recente',
    recentActivityHint: 'Últimas atividades de classificação',
    classifiedSuccessfully: 'Classificado com sucesso',
    pendingReview: 'Revisão pendente',
    hoursAgo: 'há {count} h',
    daysAgo: 'há {count} d',
    systemStatus: 'Status do sistema',
    systemStatusHint: 'Status atual dos serviços de conformidade comercial',
    serviceClassificationApi: 'API de classificação',
    serviceFileUpload: 'Upload de arquivos',
    serviceReporting: 'Relatórios',
    operational: 'Operacional',
    issues: 'Problemas'
  },
  profiles: {
    addChild: 'Adicionar perfil filho',
    idLabel: 'ID: {id}',
    information: 'Informações do perfil',
    nameLabel: 'Nome do perfil',
    namePlaceholder: 'Insira o nome do perfil',
    parentIdLabel: 'ID principal',
    noParent: 'Nenhum (raiz)',
    save: 'Salvar perfil',
    emptyTitle: 'Selecione um perfil',
    emptyHint: 'Selecione um perfil na árvore para ver e editar os detalhes',
    createTitle: 'Criar perfil filho',
    loadFailed: 'Falha ao carregar os perfis',
    detailsFailed: 'Falha ao carregar os detalhes do perfil',
    saved: 'Perfil salvo com sucesso',
    saveFailed: 'Falha ao salvar o perfil',
    nameRequired: 'Informe um nome de perfil',
    created: 'Perfil criado com sucesso',
    duplicateName: 'Já existe um perfil com este nome',
    createFailed: 'Falha ao criar o perfil'
  },
  users: {
    count: '{count} usuário | {count} usuários',
    addNew: 'Adicionar usuário',
    edit: 'Editar usuário',
    username: 'Nome de usuário',
    email: 'E-mail',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    role: 'Função',
    roleUser: 'Usuário',
    roleAdmin: 'Administrador',
    status: 'Status',
    active: 'Ativo',
    inactive: 'Inativo',
    lastLogin: 'Último acesso',
    lastLogout: 'Última saída',
    assignedProfiles: 'Perfis atribuídos',
    loadingProfiles: 'Carregando perfis…',
    resetPassword: 'Redefinir senha',
    loadFailed: 'Falha ao carregar os usuários',
    requiredFields: 'Nome de usuário, nome e e-mail são obrigatórios',
    profileRequired: 'Selecione ao menos um perfil',
    usernameExists: 'Este nome de usuário já existe',
    saved: 'Usuário salvo com sucesso',
    saveFailed: 'Falha ao salvar o usuário',
    passwordReset: 'Senha redefinida com sucesso',
    passwordResetFailed: 'Falha ao redefinir a senha'
  },
  upload: {
    colUploaded: 'Enviado em',
    colClient: 'Cliente',
    colProfile: 'Perfil',
    colDescription: 'Descrição',
    colFileName: 'Nome do arquivo',
    colQuantity: 'Quantidade',
    colStatus: 'Status',
    colErrors: 'Erros',
    stateNew: 'Novo',
    statePending: 'Pendente',
    stateRunning: 'Em execução',
    stateProcessing: 'Processando',
    stateCompleted: 'Concluído',
    stateError: 'Erro',
    countProcessed: 'Processados: {processed} de {total}',
    countSuccess: 'Sucesso: {count}',
    countErrors: 'Erros: {count}',
    countWarnings: 'Avisos: {count}',
    configTitle: 'Configuração do envio',
    configSubtitle: 'Configure as opções do seu envio',
    clientLabel: 'Cliente',
    clientPlaceholder: 'Nome do cliente',
    profileLabel: 'Perfil',
    profilePlaceholder: 'Selecione um perfil…',
    descriptionLabel: 'Descrição',
    descriptionPlaceholder: 'Insira uma descrição para este envio…',
    destinationsLabel: 'Destinos',
    destinationsPlaceholder: 'Selecione os destinos…',
    duplicateStrategy: 'Estratégia para duplicados',
    overwriteDuplicates: 'Substituir duplicados',
    ignoreDuplicates: 'Ignorar duplicados',
    actionsLabel: 'Ações',
    classification: 'Classificação',
    fileTitle: 'Envio de arquivo',
    fileSubtitle: 'Arraste e solte ou selecione os arquivos para enviar',
    dropTitle: 'Arraste e solte seus arquivos aqui',
    formatHint: 'Deve estar no formato Excel (.xlsx). Para baixar um modelo de exemplo,',
    clickHere: 'clique aqui',
    headerRowHint: 'A primeira linha do arquivo é reservada para o cabeçalho',
    selectFile: 'Selecionar arquivo para enviar',
    selectAll: 'Selecionar tudo',
    deselectAll: 'Desmarcar tudo',
    uploadedFiles: 'Arquivos enviados',
    autoRefresh: 'Atualização automática',
    confirmTitle: 'Confirmar envio',
    confirmBody: 'Este arquivo será enviado para {profile}. Tem certeza?',
    uploadAction: 'Enviar',
    listFailed: 'Falha ao carregar a lista de arquivos',
    xlsxOnly: 'Somente arquivos .xlsx são permitidos',
    tooLarge: 'O arquivo deve ter menos de 10 MB',
    processingStarted: 'Salvando o arquivo e iniciando o processamento…',
    saved: 'Arquivo salvo, será processado em breve',
    uploadFailed: 'Falha ao enviar o arquivo',
    templateFailed: 'Falha ao baixar o modelo'
  },
  reports: {
    userLabel: 'Usuário',
    profileLabel: 'Perfil',
    from: 'De',
    to: 'Até',
    exporting: 'Exportando…',
    exportDetails: 'Exportar detalhes',
    productStatistics: 'Estatísticas de produtos',
    addedProducts: 'Produtos adicionados:',
    attemptedClassifications: 'Classificações tentadas:',
    classified: 'Classificados:',
    unclassified: 'Não classificados:',
    classifiedLabel: 'Classificados',
    noData: 'Nenhum dado disponível',
    noDataShort: 'Sem dados',
    classificationsOverTime: 'Classificações ao longo do tempo',
    totalAttempted: 'Total de classificações tentadas:',
    classificationsTooltip: '{count} classificações',
    topItems: 'Top 5 itens',
    topItemsHint: 'Os 5 principais itens entre todos os produtos',
    topCategories: 'Top 5 categorias',
    topCategoriesHint: 'As 5 principais categorias de produtos não classificados',
    topCodes: 'Top 5 códigos',
    topCodesHint: 'Os 5 principais códigos de produtos classificados',
    exported: 'Relatório exportado com sucesso',
    exportFailed: 'Falha ao exportar o relatório'
  },
  adhoc: {
    title: 'Classificação de produtos',
    subtitle: 'Insira os dados do produto abaixo para obter instantaneamente a classificação do código SH.',
    descriptionLabel: 'Descrição',
    descriptionPlaceholder: 'Descreva o produto aqui…',
    descriptionHelp: 'Forneça uma descrição detalhada do produto, incluindo materiais, finalidade e características principais.',
    originLabel: 'Origem',
    originPlaceholder: 'Selecione a origem…',
    destinationLabel: 'Destino',
    destinationPlaceholder: 'Selecione o destino…',
    classify: 'Classificar',
    classifying: 'Classificando…',
    reset: 'Redefinir',
    tipsTitle: 'Dicas de classificação',
    tipsBestResults: 'Para melhores resultados:',
    tipMaterial: 'Inclua a composição dos materiais',
    tipUse: 'Especifique o uso ou a função pretendidos',
    tipCharacteristics: 'Mencione as principais características físicas',
    tipBrand: 'Inclua a marca ou o modelo, se relevante',
    tipsExamples: 'Exemplos comuns:',
    exampleShirt: 'Camiseta de algodão masculina, tamanho G',
    exampleKnife: 'Faca de cozinha em aço inoxidável, 8 polegadas',
    exampleBattery: 'Bateria de íon de lítio para smartphones',
    exampleTable: 'Mesa de jantar de madeira de carvalho, 6 lugares',
    fieldDescription: 'descrição do produto',
    fieldOrigin: 'origem',
    fieldDestination: 'destino',
    missingFields: 'Preencha todos os campos obrigatórios: {fields}',
    classificationTitle: 'Classificação',
    classificationTitleFor: 'Classificação: {description}',
    completed: 'Classificação concluída',
    completedCreateRule: 'Classificação concluída. Crie sua regra agora.',
    classifierNotStarted: 'A janela de classificação não carregou. Clique para tentar novamente.',
    missingHsCode: 'Código SH ausente para a cotação',
    quoteTitle: 'Cotação de impostos e taxas',
    quoteConfirmHeading: 'Deseja calcular impostos e taxas?',
    quoteConfirmBody: 'Isso permitirá calcular os impostos e taxas estimados para o produto classificado.',
    classificationSummary: 'Resumo da classificação',
    hsCodeLabel: 'Código SH:',
    originValueLabel: 'Origem:',
    destinationValueLabel: 'Destino:',
    stackedHsCodes: 'Códigos SH combinados:',
    noCancel: 'Não, cancelar',
    yesContinue: 'Sim, continuar',
    quoteParamsTitle: 'Inserir os parâmetros da cotação',
    classificationDetails: 'Detalhes da classificação',
    optionalParameters: 'Parâmetros opcionais',
    shipmentType: 'Tipo de envio',
    adValorem: 'Ad valorem',
    specific: 'Específico',
    currency: 'Moeda',
    countryOfOrigin: 'País de origem',
    selectCoo: 'Selecione o país de origem…',
    quantity: 'Quantidade',
    unitValue: 'Valor unitário ($)',
    total: 'Total ($)',
    shipping: 'Frete ($)',
    handling: 'Manuseio ($)',
    insurance: 'Seguro ($)',
    measureValue: 'Valor de medida',
    unit: 'Unidade',
    calculating: 'Calculando…',
    getQuote: 'Obter cotação',
    quoteResultsTitle: 'Resultados da cotação de impostos e taxas',
    quoteSummary: 'Resumo da cotação',
    quoteIdLabel: 'ID da cotação:',
    typeLabel: 'Tipo:',
    shipmentLabel: 'Envio:',
    currencyLabel: 'Moeda:',
    lineHeading: 'Linha {number} - {description}',
    hsBadge: 'SH: {code}',
    duties: 'Impostos de importação',
    taxes: 'Tributos',
    colDescription: 'Descrição',
    colAmount: 'Valor',
    colType: 'Tipo',
    colTarget: 'Alvo',
    colRate: 'Alíquota',
    dutyDetails: 'Detalhes dos impostos e aplicação do código SH',
    rateLabel: 'Alíquota:',
    methodLabel: 'Método:',
    labelLabel: 'Rótulo:',
    totalDuty: 'Total de impostos de importação',
    totalTax: 'Total de tributos',
    grandTotal: 'Total geral',
    disclaimerLabel: 'Aviso:',
    disclaimerBody: 'Estas estimativas são apenas informativas e podem não refletir os impostos e taxas efetivamente cobrados na importação.',
    close: 'Fechar'
  },
  products: {
    tabDetails: 'Detalhes',
    tabDestinations: 'Destinos',
    tabHistory: 'Histórico',
    tabAudit: 'Auditoria',
    tabCopy: 'Copiar',
    colDate: 'Data',
    colId: 'ID',
    colProfile: 'Perfil',
    colDescription: 'Descrição',
    colCustomsDesc: 'Desc. aduaneira',
    colItem: 'Item',
    colCategory: 'Categoria',
    colDutyRates: 'Alíquotas',
    productId: 'ID do produto',
    description: 'Descrição',
    customsDescription: 'Descrição aduaneira',
    client: 'Cliente',
    source: 'Fonte',
    origin: 'Origem',
    selectOrigin: 'Selecione a origem…',
    manufacturerName: 'Nome do fabricante',
    reclassify: 'Reclassificar',
    classify: 'Classificar',
    reset: 'Redefinir',
    save: 'Salvar',
    selectProductDetails: 'Selecione um produto para ver os detalhes',
    tariffPackageRequired: 'Para acessar este recurso, você precisa do pacote de dados de conteúdo tarifário.',
    destination: 'Destino',
    selectDestination: 'Selecione o destino…',
    hsCode: 'Código SH',
    lookupTariffCode: 'Consultar código tarifário',
    tariffCode: 'Código tarifário',
    addTariffCode: 'Adicionar código tarifário',
    viewCompliance: 'Ver detalhes de conformidade',
    removeDestination: 'Remover destino',
    valid: 'Válido',
    invalid: 'Inválido',
    restrictions: 'Restrições',
    selectProductDestinations: 'Selecione um produto para ver os destinos',
    noHistory: 'Nenhum histórico disponível',
    questions: 'Perguntas',
    rationale: 'Justificativa',
    hsVersion: 'Versão SH',
    noAudit: 'Nenhuma informação de auditoria disponível',
    copyFields: 'Copiar campos',
    copyTo: 'Copiar para',
    checkedProducts: 'Os produtos que marquei',
    allListedProducts: 'Todos os produtos listados atualmente',
    productCount: '{count} produtos',
    whenDataExists: 'Quando já existem dados',
    overwrite: 'Substituir os dados existentes',
    doNotOverwrite: 'Não substituir os dados existentes',
    copying: 'Copiando…',
    copy: 'Copiar',
    selectProductCopy: 'Selecione um produto para configurar as opções de cópia',
    loadingProduct: 'Carregando as informações do produto…',
    matching: 'Correspondentes: {count}',
    checked: 'Marcados: {count}',
    exportAction: 'Exportar',
    reclassifyAction: 'Reclassificar',
    addProduct: 'Adicionar produto',
    filters: 'Filtros',
    newProduct: 'Novo produto',
    productIdRequired: 'O ID do produto é obrigatório.',
    descriptionRequired: 'A descrição é obrigatória.',
    profile: 'Perfil',
    selectProfile: 'Selecione um perfil…',
    reclassifyTitle: 'Reclassificar produtos',
    reclassifyConfirm: 'Tem certeza de que deseja reclassificar {count} produtos?',
    reclassifyNeedsSelection: 'Marque antes os produtos a reclassificar',
    reclassifyScopeQuestion: 'Quais produtos você quer reclassificar?',
    reclassifyScopeChecked: 'Somente os produtos que marquei',
    reclassifyScopeAll: 'Todos os produtos do filtro, em todas as páginas',
    reclassifyWarning: 'Isso pode afetar outros usuários até a conclusão do processo.',
    reclassifyProgress: 'Reclassificando produtos… {count}',
    processing: 'Processando…',
    complianceTitle: 'Informações de conformidade',
    add: 'ADD',
    cvd: 'CVD',
    pga: 'PGA',
    yes: 'SIM',
    no: 'NÃO',
    mfnRate: 'Alíquota NMF',
    exportTitle: 'Exportar produtos',
    exportConfirm: 'Deseja exportar a lista atual de produtos (de acordo com os filtros ativos) para o Excel?',
    exportHint: 'O arquivo será gerado e seu navegador iniciará o download automaticamente.',
    preparingExcel: 'Preparando o arquivo do Excel. Seu navegador iniciará o download em breve.',
    dutyRatesTitle: 'Alíquotas',
    loadingDutyRates: 'Carregando as alíquotas…',
    dutyRateDetails: 'Detalhes das alíquotas',
    noDetailedDutyRates: 'Nenhuma alíquota detalhada disponível.',
    noDutyRates: 'Nenhuma alíquota disponível para este produto.',
    classifiedHsVersion: 'Classificado / Versão SH',
    all: 'Todos',
    classified: 'Classificados',
    notClassified: 'Não classificados',
    hsYear: 'Ano SH',
    item: 'Item',
    category: 'Categoria',
    fromTo: 'De / Até',
    search: 'Pesquisar',
    dutyRatesFailed: 'Falha ao carregar as alíquotas',
    detailsFailed: 'Falha ao carregar os detalhes do produto',
    saved: 'Produto salvo com sucesso',
    saveFailed: 'Falha ao salvar o produto',
    profileNotReady: 'O perfil do usuário não está pronto para a cópia',
    noCopyTargets: 'Nenhum produto de destino selecionado para a cópia',
    noCopySources: 'Nenhum campo de origem disponível para copiar',
    copied: 'Campos copiados com sucesso',
    copyFailed: 'Falha ao copiar os campos para os produtos',
    copyStillRunning: 'A cópia não terminou e pode continuar rodando no servidor. Confira os produtos antes de copiar de novo.',
    copyLeaveConfirm: 'Há uma cópia em andamento. Se você sair desta página, ela continua no servidor, mas você não verá se deu certo. Sair mesmo assim?',
    createRequiredFields: 'O ID do produto e a descrição são obrigatórios',
    created: 'Produto criado com sucesso',
    createFailed: 'Falha ao criar o produto',
    classifyRequirements: 'É necessária uma descrição aduaneira ou um código SH existente para classificar este produto',
    classifying: 'Classificando o produto…',
    noHsCode: 'O classificador não retornou nenhum código SH',
    noHsYear: 'A classificação foi retornada sem a informação do ano SH',
    classifiedOk: 'Produto classificado com sucesso',
    classifyCancelled: 'Classificação cancelada ou com falha',
    classifierNotStarted: 'A janela de classificação não carregou. Clique para tentar novamente.',
    reclassifyStarted: 'Reclassificação iniciada',
    reclassifyFailed: 'Falha ao iniciar a reclassificação',
    exportFailed: 'Falha na exportação',
    complianceFailed: 'Falha ao carregar os dados de conformidade',
    tariffSaved: 'Código tarifário salvo',
    tariffSaveFailed: 'Falha ao salvar o código tarifário',
    tariffSuggested: 'Código tarifário sugerido pelo classificador',
    noTariffCode: 'O classificador não retornou nenhum código tarifário',
    tariffLookupFailed: 'Falha na consulta do código tarifário',
    deletingDestination: 'Excluindo o destino {destination}…',
    destinationDeleted: 'Destino excluído',
    destinationDeleteFailed: 'Falha ao excluir o destino'
  },
  rules: {
    title: 'Regras de classificação',
    subtitle: 'Consulte as regras de classificação salvas que preenchem automaticamente as respostas durante a classificação de produtos.',
    count: 'Você tem {count} regras',
    create: 'Criar regra',
    classifyFirst: 'Classifique um produto primeiro para criar uma regra.',
    filterPlaceholder: 'Filtrar por nome ou item…',
    filterAria: 'Filtrar regras',
    rowHint: 'Clique em uma linha para ver os detalhes da regra',
    colRuleName: 'Nome da regra',
    colItem: 'Item',
    colSip: 'SIP',
    detailsTitle: 'Detalhes da regra',
    ruleNameLabel: 'Nome da regra:',
    itemLabel: 'Item:',
    sipLabel: 'SIP:',
    constraints: 'Restrições',
    constraintsCaption: 'Restrições da regra selecionada',
    colCategory: 'Categoria',
    colType: 'Tipo',
    colValues: 'Valores',
    typeSelection: 'Seleção',
    typeValued: 'Valorado',
    deleting: 'Excluindo…',
    deleteRule: 'Excluir regra',
    close: 'Fechar',
    createTitle: 'Criar regra de classificação',
    ruleNameField: 'Nome da regra',
    ruleNamePlaceholder: 'ex. Camisetas de algodão',
    itemNameField: 'Nome do item',
    itemNamePlaceholder: 'ex. Camiseta',
    sipField: 'SIP',
    sipPlaceholder: 'ex. 6109.10',
    hsCodeLabel: 'Código SH:',
    originLabel: 'Origem:',
    destinationLabel: 'Destino:',
    interactions: 'Interações',
    selectAll: 'Selecionar tudo',
    unselectAll: 'Desmarcar tudo',
    selectedCount: 'Interações selecionadas: {count}',
    ruleApplied: 'Regra aplicada',
    ruleMismatch: 'Divergência de regra',
    category: 'Categoria',
    type: 'Tipo',
    values: 'Valores',
    select: 'Selecionar',
    deleteTitle: 'Excluir regra',
    deleteConfirm: 'Esta ação não pode ser desfeita. Excluir {name}?',
    delete: 'Excluir',
    classifyBeforeCreate: 'Classifique um produto antes de criar uma regra.',
    noProfile: 'Nenhum perfil selecionado para operações com regras',
    requiredFields: 'O nome da regra, o item e o SIP são obrigatórios',
    selectInteraction: 'Selecione ao menos uma interação',
    itemInteractionRequired: 'Esta regra não pode ser salva sem selecionar a interação do item.',
    selectOneOption: 'Selecione uma opção para "{label}"',
    enterValues: 'Insira valores para "{label}"',
    valuesMustTotal: 'Os valores de "{label}" devem somar 100%',
    created: 'Regra criada com sucesso',
    createFailed: 'Falha ao criar a regra',
    deleted: 'Regra excluída com sucesso',
    deleteFailed: 'Falha ao excluir a regra'
  },
  table: {
    noData: 'Nenhum dado disponível',
    downloadErrorFile: 'Baixar o arquivo de erros',
    showing: 'Exibindo {from} - {to} de {total}',
    perPage: '{size} por página',
    requiresAccess: 'Este recurso requer acesso adicional'
  },
  header: {
    greeting: 'Olá {name}'
  }
}

export default pt
